(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    module.exports = factory();
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function() {
  'use strict';

  /**
   * String related utility methods
   *
   * @class stringUtils
   * @static
   */
  return {
    /**
     * Polyfill for string starts with (not supported by all browsers).
     * @method startsWith
     * @param string {String} the string to search
     * @param value {String} the string to search for.
     * @returns {Boolean} true if the string starts with the given value.
     */
    startsWith: function(string, value) {
      return string.indexOf(value) === 0;
    },
    /**
     * Polyfill for string ends with (not supported by all browsers).
     * @method endsWith
     * @param string {String} the string to search
     * @param search {String} the string to search for.
     * @param [length=string.length] {Number} the length of the string to consider, defaults to string.length.
     * @returns {Boolean} true if the string ends with the given value.
     *                    If both string and search are empty, then return true.
     *                    If searching a blank string for a non-blank value, then return false.
     */
    endsWith: function(string, search, length) {
      if (!string && search) {
        return false;
      }
      if (!string && !search) {
        return true;
      }
      if (length === undefined || length > string.length) {
        length = string.length;
      }
      var substringToCheck = string.substring(length - search.length, length);
      return substringToCheck === search;
    },

    /**
     * @param value {String} the value to trim leading and trailing spaces from.
     * @returns {String} the trimmed value - guaranteed to be a string (null / undefined converted to empty strings).
     */
    nullSafeTrim: function(value) {
      if (typeof(value) === 'undefined' || value === null) {
        return '';
      } else {
        return value.trim();
      }
    },

    /**
     * @param value {String} the value to replace all spaces from.
     * @returns {String} the value without any leading and trailing or in between spaces - guaranteed to be a string (null / undefined converted to empty strings).
     */
    nullSafeReplaceAllSpaces: function(value) {
      if (typeof(value) === 'undefined' || value === null) {
        return '';
      } else {
        return value.replace(/\s+/g, '');
      }
    },

    /**
     * @param value {String} the value to trim leading and trailing spaces and convert all to uppercase from.
     * @returns {String} the trimmed and uppercase value - guaranteed to be a string (null / undefined converted to empty strings).
     */
    nullSafeTrimAllUpperCase: function(value) {
      if (typeof(value) === 'undefined' || value === null) {
        return '';
      } else {
        return value.trim().toUpperCase();
      }
    },

    /**
     * @param value {String} the value to trim leading and trailing spaces and convert all to lowercase from.
     * @returns {String} the trimmed and lowercase value - guaranteed to be a string (null / undefined converted to empty strings).
     */
    nullSafeTrimAllLowerCase: function(value) {
      if (typeof(value) === 'undefined' || value === null) {
        return '';
      } else {
        return value.trim().toLowerCase();
      }
    },

    /**
     * @param value {String} the value to replace all spaces from.
     * @returns {String} the value that all white space are replaced by dot - guaranteed to be a string (null / undefined converted to empty strings).
     */
    nullSafeReplaceAllSpacesByDot: function(value) {
      if (typeof(value) === 'undefined' || value === null) {
        return '';
      } else {
        return value.replace(/\s+/g, '.');
      }
    },

    /**
     * Converts the first character of string to upper case and the rest to lower case.
     * @method capitalize
     * @param string {String} The string to capitalize.
     * @returns {String} Returns the capitalized string.
     */
    capitalize: function(string) {
      return string == null ? '' : string.charAt(0).toUpperCase() + string.substring(1).toLowerCase();
    }
  };
}));
